import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";
import { StyledFixedBottomButton } from "@/styles/components/button/StyledFixedBottomButton";

export const StyledCookieButton = styled(StyledFixedBottomButton)``;

export const StyledConsentContainer = styled.div`
    position: fixed;
    bottom: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    width: auto;
    width: fill-available;
    padding: 20px 40px 20px 40px;
    background: var(--color-selected);
    box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.05);
    @media ${breakpoints.lg} {
        padding: 32px 99px 34px 99px;
    }
    @media ${breakpoints.sm} {
        padding: 10px 20px 10px 20px;
    }

    .closeConsentContainer {
        position: absolute;
        top: 2rem;
        right: 2rem;
        cursor: pointer;
    }

    .title-container {
        display: flex;
        align-items: center;
        padding-bottom: 0;
        font-size: var(--size-18);
        font-weight: bold;
        line-height: 27px;
        color: var(--color-primary);
        @media ${breakpoints.xs} {
            font-size: var(--size-16);
        }
    }

    .infoContainer {
        display: flex;
        flex-direction: row;
        width: 100%;
        font-style: normal;
        @media ${breakpoints.sm} {
            display: block;
        }

        .messageContainer {
            display: flex;
            flex-direction: column;
            width: 68%;
            margin-top: 10px;
            margin-right: 2%;
            margin-bottom: 10px;
            font-size: var(--size-16);
            font-weight: normal;
            line-height: 24px;
            color: var(--color-grey-900);
            @media ${breakpoints.sm} {
                width: 100%;
                font-size: var(--size-14);
            }

            span {
                display: inline;
                align-items: center;
                font-size: var(--size-12);
                font-weight: bold;
                line-height: 18px;
                color: var(--color-primary);
                text-decoration-line: underline;
                cursor: pointer;
            }
        }
    }

    .buttonContainer {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
        width: 30%;
        @media ${breakpoints.sm} {
            display: block;
            flex-direction: column;
            justify-content: space-evenly;
            width: 100%;
        }

        .linkButton {
            display: flex;
            justify-content: center;
            font-size: var(--size-16);
            font-weight: bold;
            line-height: 22px;
            color: var(--color-secondary);
            text-decoration-line: underline;
            cursor: pointer;
        }

        .cookieButtons {
            width: 100%;
            height: min-content;
            margin-right: 10px;

            &:first-child {
                @media ${breakpoints.sm} {
                    margin-right: 0;
                    margin-bottom: 10px;
                }
            }
        }
    }

    .readMoreContainer {
        width: 100%;
        color: var(--color-grey-900);
        @media ${breakpoints.lg} {
            width: 50%;
        }

        ul {
            li {
                margin-top: 12px;
                font-size: var(--size-14);
                font-weight: bold;
                line-height: 21px;
                @media ${breakpoints.xs} {
                    font-size: var(--size-12);
                }
            }

            .switcher {
                display: flex;
                flex-direction: row;
                font-size: var(--size-12);
                font-weight: normal;
                line-height: 18px;
                @media ${breakpoints.xs} {
                    font-size: var(--size-10);
                }

                .text {
                    width: 70%;
                }

                .switcher {
                    width: 30%;
                }
            }
        }
    }
`;
